import { Component, OnInit } from '@angular/core';
import { PersistenceService } from '@app/_services/persistence.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public persistenceService: PersistenceService,
  ) {
    persistenceService.initializeLocalStorageItems();
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(persistenceService.getLang());

  }

  // Basically reloads the page on inactive tabs or windows when changes detected in localStorage/currentUser
  // Originally created for multi organization shenanigans but might need to revisit since refresh token was added
  // @HostListener('window:storage', ['$event']) handleStorageChange(event: StorageEvent) {
  //   if (event.key === 'currentUser') {
  //     this.authService.setCurrentUserFromStorage();
  //     this.router.navigate(['login']);
  //   }
  // }

  ngOnInit() { }

}
